export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';

export const APP_VERSION = process.env.APP_VERSION;

export const DEVELOPMENT_LOCAL_API_URL = 'http://localhost:8080/api/';
export const API_URL = process.env.API_URL && `${process.env.API_URL}/api/` || DEVELOPMENT_LOCAL_API_URL;

export const PROXY_API_URL = 'https://tcf-reverse-proxy.herokuapp.com/';

export const STORAGE_BUCKET_URL = `https://storage.googleapis.com`;
